import axios from 'axios'

import { locateCountry } from '@last/core'
import { errors } from '@last/core/src/errorManager.js'

import { useLocationsStore } from '@/modules/locations/store/locations'
import { useAuthStore } from '@/store/auth.js'
import pinia from '@/store/index'

let country = locateCountry()

const api = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL
})

api.interceptors.request.use(
  async config => {
    const auth = useAuthStore(pinia)
    const locations = useLocationsStore(pinia)
    const token = auth.accessToken
    if (token) {
      config.headers['Authorization'] = token
    }

    const selectedOrganizationId = locations.selectedOrganizationId
    if (selectedOrganizationId) {
      config.headers['Organization-ID'] = selectedOrganizationId
    }

    const selectedLocationId = locations.selectedLocationId
    if (selectedLocationId) {
      config.headers['Location-ID'] = selectedLocationId
    }

    const datadogUserId = auth.user.id
    if (datadogUserId) {
      config.headers['Datadog-User-ID'] = datadogUserId
    }

    config.headers['Country-Code'] = await country
    return config
  },

  error => {
    return Promise.reject(error)
  }
)

api.interceptors.response.use(
  response => {
    return response
  },

  async error => {
    if (axios.isCancel(error)) {
      return Promise.reject(error)
    }
    const locations = useLocationsStore(pinia)
    const auth = useAuthStore(pinia)
    switch (error.response.data.code) {
      case errors.locationNotAllowed.code:
        locations.removeSelectedLocation()
        break
      case errors.invalidToken.code:
        auth.clearAndGoToLogin()
    }

    return Promise.reject(error)
  }
)

export default api
